import { render, staticRenderFns } from "./PersonalPropertyProductSearch.vue?vue&type=template&id=d2be8f6c"
import script from "./PersonalPropertyProductSearch.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyProductSearch.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyProductSearch.vue?vue&type=style&index=0&id=d2be8f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports